export interface AppSettings {
  apiEndpoint: string;
  region: string;
  roleArn: string;
  midwayEndpoint: string;
  stage: string;
  /** When set, API requests are signed against apiEndpoint but fetched via this local proxy path (for local dev). */
  proxyEndpoint?: string;
}

let cachedSettings: AppSettings | null = null;

export async function getSettings(): Promise<AppSettings> {
  if (cachedSettings) return cachedSettings;
  const response = await fetch('/settings.json');
  if (!response.ok) throw new Error('Failed to load settings.json');
  cachedSettings = await response.json();
  return cachedSettings!;
}
